module.exports = __webpack_public_path__ + "static/media/canalboldromain.2ab100b6.woff";